module.exports = __webpack_public_path__ + "img/express.0d00ef62.png";